export default function Footer() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/258869689262', '_blank');
  };

  return (
    <footer className="bg-gradient-to-br from-orange-500 via-pink-500 to-yellow-500 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <h3 className="text-3xl font-bold mb-4">Mundo Crocs</h3>
            <p className="text-white/90 mb-6 leading-relaxed">
              Loja moçambicana de Crocs personalizados com pins decorativos. Estilo único, conforto garantido.
            </p>
            <div className="flex gap-4">
              <button
                onClick={handleWhatsAppClick}
                className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
              </button>
              <button
                onClick={handleWhatsAppClick}
                className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-2xl"></i>
              </button>
              <button
                onClick={handleWhatsAppClick}
                className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Navegação</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Início
                </a>
              </li>
              <li>
                <a href="#produtos" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Produtos
                </a>
              </li>
              <li>
                <a href="#sobre" className="text-white/90 hover:text-white transition-colors cursor-pointer">
                  Sobre Nós
                </a>
              </li>
              <li>
                <button
                  onClick={handleWhatsAppClick}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">Contacto</h4>
            <div className="space-y-4">
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center gap-3 text-white/90 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-whatsapp-line text-xl"></i>
                </div>
                <div className="text-left">
                  <p className="text-sm text-white/70">WhatsApp</p>
                  <p className="font-semibold">+258 869 689 262</p>
                </div>
              </button>
              
              <div className="flex items-center gap-3 text-white/90">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div className="text-left">
                  <p className="text-sm text-white/70">Localização</p>
                  <p className="font-semibold">Moçambique</p>
                </div>
              </div>

              <div className="flex items-center gap-3 text-white/90">
                <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-price-tag-3-line text-xl"></i>
                </div>
                <div className="text-left">
                  <p className="text-sm text-white/70">Preço Fixo</p>
                  <p className="font-semibold">1.800 MZN</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/80 text-sm">
            © 2025 Mundo Crocs Moçambique. Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
